<div class="defective-items-modal">
  <app-nc-defective-items-carousel [defectiveItems]="defectiveItems" [isFullscreen]="true"></app-nc-defective-items-carousel>
</div>
